module.exports = __webpack_public_path__ + "static/media/filter-data-icon.926d8d8c.svg";